import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { IntegrationsAction } from './integrations.actions';
import { IntegrationsService } from 'src/app/services/integrations/integrations.service';
import { tap } from 'rxjs/operators';
import { patch } from '@ngxs/store/operators';

export interface Integration {
  id: number;
  schema: any;
}
export class IntegrationsStateModel {
  public integrations: Integration[];
}

const defaults = {
  integrations: [],
};

@State<IntegrationsStateModel>({
  name: 'integrations',
  defaults
})
@Injectable()
export class IntegrationsState {
  constructor(
    private integrationsService: IntegrationsService,
  ) { }
  @Action(IntegrationsAction.LoadIntegrations)
  load(
    { setState }: StateContext<IntegrationsStateModel>,
  ) {
    return this.integrationsService.getIntegrations()
    .pipe(
      tap(
        (integrationsResponseData) => {
          setState(
            patch({
              integrations: integrationsResponseData.integrations,
            })
          )
        },
        () => {}
      )
    )
  }
  @Action(IntegrationsAction.postFormDataIntegration)
  postData(
    { setState }: StateContext<IntegrationsStateModel>,
    { integrationId, formData }: IntegrationsAction.postFormDataIntegration
  ) {
    return this.integrationsService.postFormDataIntegration(integrationId,formData)
    .pipe(
      tap(
        (integrationsResponseData) => {},
        () => {}
      )
    )
  }
}
